module.exports = __webpack_public_path__ + "static/img/1081_big.20e14b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1081_big.png
// module id = 2Aj4
// module chunks = 1